import { render } from "./MessageFilter.vue?vue&type=template&id=52b43b8e&scoped=true"
import script from "./MessageFilter.vue?vue&type=script&lang=js"
export * from "./MessageFilter.vue?vue&type=script&lang=js"

import "./MessageFilter.vue?vue&type=style&index=0&id=52b43b8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b43b8e"]])

export default __exports__